import type { JSX } from 'react'

import { TOAPopup } from "/app/libraries/arcana/src/blocks/Popup/Templates/index.ts"

import { useUnit } from 'effector-react'
import { useTranslation } from 'react-i18next'
import { AppTitle } from '~/shared/ui/components/AppTitle'
import { useErrorMessage } from '~/widgets/Popups/MessagePortal'
import { $message, $toa, $wasLoadingError, error } from '../model'
import { Body } from './Body'
import { Buttons } from './Buttons'
import { TOALayout } from './TOALayout'

export function Title(): JSX.Element {
  return <AppTitle t='terms_of_agreements' />
}

ToaPage.displayName = 'ToaPage'
export function ToaPage(): JSX.Element | null {
  const { t } = useTranslation()

  const message = useUnit($message)

  const { toa, err, wasLoadingError } = useUnit({
    toa: $toa,
    err: error.$loading,
    wasLoadingError: $wasLoadingError,
  })

  const emptyBody = Boolean(err || wasLoadingError)
  const subtitle = emptyBody ? '' : toa?.subject

  useErrorMessage(message, 'ToaPage')

  return (
    <TOALayout>
      <TOAPopup
        title={t('terms_of_agreements')}
        subtitle={subtitle}
        emptyBody={emptyBody}
      >
        <Body />
        <Buttons />
      </TOAPopup>
    </TOALayout>
  )
}
